function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213.526 115.015C213.526 115.015 212.338 112.576 212.023 109.518C211.864 107.975 211.927 106.275 212.479 104.651C214.121 99.8108 217.931 99.1987 221.476 101.245C225.022 103.293 226.397 106.898 223.027 110.741C219.655 114.584 213.526 115.015 213.526 115.015Z",
  fill: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M215.69 111.268C215.69 111.268 214.892 109.62 214.685 107.552C214.58 106.509 214.626 105.359 215.001 104.259C216.117 100.982 218.688 100.562 221.075 101.94C223.463 103.319 224.384 105.755 222.105 108.361C219.824 110.966 215.69 111.268 215.69 111.268Z",
  fill: "#FFA621"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.853 107.521C217.853 107.521 217.367 106.618 217.204 105.504C217.122 104.941 217.122 104.325 217.308 103.743C217.862 102.009 219.299 101.841 220.674 102.635C222.049 103.429 222.622 104.757 221.398 106.105C220.173 107.452 217.853 107.521 217.853 107.521Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.029 102.359C232.807 102.742 232.317 102.874 231.933 102.652L214.799 92.7599C214.415 92.5384 214.284 92.0478 214.505 91.6642L215.441 90.0434L233.964 100.738L233.029 102.359Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M229.376 103.337C229.155 103.721 228.664 103.852 228.281 103.631L215.777 96.412C215.394 96.1905 215.262 95.6999 215.484 95.3163L216.42 93.6955L230.312 101.716L229.376 103.337Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M236.948 100.917C236.579 101.556 235.761 101.775 235.122 101.406L214.283 89.3747C213.644 89.0055 213.425 88.188 213.794 87.5486L221.588 74.0477C221.813 73.6587 222.218 73.4085 222.666 73.3817L237.056 72.5205C237.59 72.4886 238.092 72.7783 238.331 73.2569L244.78 86.1492C244.981 86.5509 244.967 87.0267 244.742 87.4156L236.948 100.917Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.13 95.1269L234.705 87.5377L226.502 82.8021L218.217 83.6305L216.461 86.6726C216.092 87.312 216.311 88.1295 216.95 88.4987L234.547 98.6583C235.187 99.0275 236.004 98.8084 236.373 98.169L238.13 95.1269Z",
  fill: "#DEDCDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.372 74.3428C237.229 74.0494 236.922 73.8722 236.596 73.8947L222.979 74.7646C222.398 74.8047 222.053 75.4296 222.326 75.9425L228.545 87.8883C228.689 88.1579 228.973 88.3222 229.279 88.3121L242.733 87.7244C243.314 87.7051 243.683 87.0931 243.427 86.5706L237.372 74.3428Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M236.948 100.917C236.579 101.556 235.761 101.775 235.122 101.406L214.284 89.3752C213.644 89.006 213.425 88.1884 213.794 87.5491L216.203 83.3762L230.134 84.9073C230.507 84.9482 230.844 85.1433 231.066 85.4452L239.357 96.7441L236.948 100.917Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M227.189 267.159C227.189 267.159 225.859 264.427 225.506 261.003C225.328 259.275 225.399 257.372 226.017 255.553C227.856 250.133 232.122 249.448 236.092 251.74C240.063 254.032 241.602 258.069 237.828 262.373C234.053 266.676 227.189 267.159 227.189 267.159Z",
  fill: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M229.612 262.963C229.612 262.963 228.72 261.117 228.488 258.802C228.37 257.633 228.422 256.346 228.841 255.114C230.091 251.445 232.969 250.974 235.643 252.518C238.317 254.062 239.348 256.79 236.796 259.707C234.242 262.625 229.612 262.963 229.612 262.963Z",
  fill: "#FFA621"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.035 258.767C232.035 258.767 231.491 257.756 231.309 256.508C231.216 255.878 231.216 255.188 231.425 254.536C232.045 252.595 233.655 252.407 235.194 253.295C236.734 254.184 237.375 255.672 236.005 257.181C234.633 258.689 232.035 258.767 232.035 258.767Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M249.028 252.986C248.78 253.415 248.231 253.563 247.801 253.315L228.615 242.237C228.185 241.989 228.038 241.44 228.286 241.01L229.334 239.196L250.076 251.171L249.028 252.986Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M244.938 254.082C244.69 254.511 244.141 254.658 243.711 254.41L229.711 246.327C229.281 246.079 229.134 245.53 229.382 245.1L230.43 243.285L245.986 252.267L244.938 254.082Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M253.417 251.371C253.003 252.087 252.088 252.333 251.372 251.919L228.037 238.447C227.321 238.033 227.076 237.118 227.489 236.402L236.218 221.284C236.469 220.848 236.922 220.568 237.425 220.538L253.538 219.574C254.136 219.538 254.698 219.862 254.966 220.398L262.187 234.835C262.412 235.285 262.397 235.818 262.145 236.253L253.417 251.371Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.74 244.888L250.905 236.39L241.72 231.087L232.443 232.015L230.476 235.421C230.063 236.137 230.308 237.053 231.024 237.466L250.729 248.843C251.445 249.256 252.36 249.011 252.774 248.295L254.74 244.888Z",
  fill: "#DEDCDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.892 221.614C253.731 221.286 253.387 221.087 253.023 221.113L237.774 222.087C237.125 222.132 236.737 222.831 237.044 223.406L244.007 236.782C244.168 237.084 244.487 237.268 244.829 237.257L259.895 236.599C260.546 236.577 260.958 235.892 260.672 235.307L253.892 221.614Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M253.417 251.372C253.004 252.088 252.088 252.333 251.372 251.92L228.037 238.447C227.321 238.034 227.076 237.118 227.489 236.402L230.187 231.73L245.787 233.444C246.204 233.49 246.582 233.708 246.83 234.047L256.115 246.699L253.417 251.372Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M383.872 288.755C383.872 288.755 381.979 284.868 381.477 279.995C381.223 277.536 381.324 274.827 382.203 272.24C384.82 264.526 390.891 263.551 396.541 266.813C402.192 270.075 404.382 275.82 399.012 281.944C393.639 288.069 383.872 288.755 383.872 288.755Z",
  fill: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.32 282.784C387.32 282.784 386.05 280.158 385.72 276.862C385.553 275.2 385.626 273.367 386.223 271.615C388.001 266.393 392.097 265.723 395.902 267.92C399.708 270.117 401.175 273.999 397.543 278.151C393.909 282.303 387.32 282.784 387.32 282.784Z",
  fill: "#FFA621"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M390.768 276.813C390.768 276.813 389.994 275.374 389.734 273.598C389.603 272.702 389.603 271.72 389.899 270.793C390.782 268.03 393.073 267.762 395.263 269.027C397.454 270.292 398.368 272.409 396.417 274.556C394.465 276.703 390.768 276.813 390.768 276.813Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M414.95 268.586C414.597 269.198 413.815 269.407 413.204 269.054L385.901 253.29C385.289 252.937 385.08 252.156 385.433 251.544L386.924 248.962L416.441 266.003L414.95 268.586Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M409.13 270.146C408.777 270.757 407.995 270.966 407.384 270.613L387.46 259.11C386.848 258.757 386.639 257.975 386.992 257.364L388.483 254.781L410.621 267.563L409.13 270.146Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.195 266.288C420.607 267.307 419.304 267.656 418.285 267.068L385.078 247.896C384.059 247.308 383.71 246.005 384.298 244.986L396.72 223.472C397.077 222.852 397.723 222.453 398.437 222.411L421.367 221.038C422.219 220.987 423.018 221.449 423.4 222.212L433.677 242.756C433.997 243.396 433.974 244.154 433.616 244.774L421.195 266.288Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.079 257.062L417.621 244.969L404.55 237.422L391.348 238.742L388.549 243.59C387.961 244.609 388.31 245.912 389.329 246.5L417.37 262.69C418.389 263.278 419.692 262.929 420.28 261.91L423.079 257.062Z",
  fill: "#DEDCDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.871 223.942C421.643 223.474 421.154 223.192 420.635 223.228L398.935 224.614C398.011 224.678 397.459 225.674 397.896 226.491L407.805 245.527C408.034 245.957 408.488 246.219 408.975 246.203L430.415 245.266C431.341 245.235 431.927 244.26 431.521 243.428L421.871 223.942Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.196 266.289C420.608 267.308 419.305 267.657 418.286 267.069L385.079 247.897C384.06 247.308 383.711 246.006 384.299 244.987L388.138 238.337L410.338 240.777C410.931 240.842 411.469 241.153 411.822 241.634L425.035 259.639L421.196 266.289Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.348 172.583C407.348 172.583 406.441 170.722 406.201 168.389C406.079 167.212 406.128 165.915 406.548 164.676C407.801 160.983 410.708 160.516 413.413 162.078C416.119 163.64 417.167 166.39 414.596 169.322C412.024 172.254 407.348 172.583 407.348 172.583Z",
  fill: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.998 169.724C408.998 169.724 408.39 168.467 408.232 166.889C408.152 166.093 408.187 165.216 408.473 164.377C409.324 161.877 411.285 161.556 413.107 162.608C414.929 163.66 415.632 165.518 413.893 167.506C412.153 169.494 408.998 169.724 408.998 169.724Z",
  fill: "#FFA621"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M410.649 166.865C410.649 166.865 410.278 166.177 410.154 165.326C410.091 164.897 410.091 164.427 410.233 163.983C410.656 162.66 411.752 162.532 412.801 163.138C413.85 163.743 414.288 164.757 413.354 165.785C412.419 166.813 410.649 166.865 410.649 166.865Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M422.227 162.927C422.058 163.219 421.684 163.32 421.391 163.151L408.319 155.603C408.026 155.434 407.926 155.06 408.095 154.767L408.809 153.531L422.941 161.69L422.227 162.927Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M419.44 163.673C419.271 163.966 418.897 164.066 418.604 163.897L409.065 158.39C408.772 158.221 408.672 157.846 408.841 157.554L409.555 156.317L420.154 162.437L419.44 163.673Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.217 161.826C424.935 162.314 424.311 162.481 423.824 162.2L407.925 153.02C407.437 152.739 407.27 152.115 407.552 151.627L413.499 141.327C413.67 141.03 413.979 140.839 414.321 140.819L425.299 140.162C425.707 140.137 426.09 140.358 426.272 140.723L431.193 150.56C431.346 150.866 431.335 151.229 431.164 151.526L425.217 161.826Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.119 157.409L423.506 151.619L417.248 148.006L410.927 148.638L409.587 150.959C409.305 151.447 409.472 152.071 409.96 152.352L423.386 160.104C423.874 160.385 424.497 160.218 424.779 159.73L426.119 157.409Z",
  fill: "#DEDCDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.541 141.552C425.431 141.328 425.197 141.193 424.949 141.21L414.559 141.874C414.117 141.904 413.853 142.381 414.062 142.772L418.806 151.886C418.916 152.092 419.133 152.217 419.366 152.21L429.631 151.761C430.075 151.747 430.356 151.28 430.161 150.881L425.541 141.552Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.217 161.827C424.936 162.315 424.312 162.482 423.824 162.2L407.925 153.021C407.437 152.739 407.27 152.115 407.552 151.628L409.39 148.444L420.019 149.612C420.303 149.643 420.56 149.792 420.729 150.023L427.055 158.643L425.217 161.827Z",
  fill: "white"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M361.332 65.4368C361.332 65.4368 359.746 62.1793 359.325 58.0958C359.112 56.0354 359.197 53.7656 359.934 51.5969C362.127 45.1331 367.214 44.3157 371.949 47.049C376.684 49.7832 378.52 54.5975 374.02 59.7293C369.517 64.8618 361.332 65.4368 361.332 65.4368Z",
  fill: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M364.222 60.433C364.222 60.433 363.157 58.2322 362.88 55.4708C362.74 54.0774 362.802 52.5419 363.302 51.0736C364.792 46.6976 368.225 46.136 371.413 47.9767C374.603 49.8181 375.832 53.0715 372.788 56.5506C369.743 60.0301 364.222 60.433 364.222 60.433Z",
  fill: "#FFA621"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M367.111 55.4294C367.111 55.4294 366.462 54.2241 366.244 52.7356C366.134 51.9845 366.134 51.1616 366.383 50.3847C367.123 48.0691 369.042 47.8449 370.878 48.9047C372.714 49.9649 373.479 51.739 371.845 53.5381C370.209 55.3373 367.111 55.4294 367.111 55.4294Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.376 48.5352C387.08 49.0475 386.425 49.223 385.913 48.9273L363.032 35.7172C362.52 35.4214 362.344 34.7663 362.64 34.254L363.89 32.0896L388.625 46.3708L387.376 48.5352Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M382.499 49.8419C382.203 50.3542 381.548 50.5297 381.036 50.2339L364.339 40.5941C363.827 40.2983 363.651 39.6433 363.947 39.131L365.196 36.9666L383.748 47.6775L382.499 49.8419Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M392.61 46.6097C392.117 47.4636 391.025 47.7561 390.171 47.2631L362.343 31.1968C361.489 30.7038 361.197 29.612 361.69 28.7582L372.099 10.7292C372.399 10.2098 372.94 9.87564 373.538 9.83981L392.754 8.68983C393.467 8.64714 394.138 9.03402 394.457 9.67317L403.069 26.8895C403.338 27.4259 403.319 28.0613 403.019 28.5807L392.61 46.6097Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M394.188 38.8781L389.614 28.7435L378.661 22.4196L367.597 23.5258L365.252 27.5882C364.759 28.4421 365.051 29.5339 365.905 30.0268L389.404 43.5939C390.258 44.0869 391.35 43.7944 391.843 42.9405L394.188 38.8781Z",
  fill: "#DEDCDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M393.176 11.123C392.985 10.7312 392.575 10.4946 392.14 10.5247L373.955 11.6863C373.181 11.7399 372.719 12.5743 373.084 13.2593L381.388 29.2116C381.58 29.5716 381.961 29.7911 382.369 29.7776L400.336 28.9928C401.112 28.967 401.603 28.1498 401.262 27.4521L393.176 11.123Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M392.61 46.61C392.117 47.4638 391.025 47.7564 390.171 47.2634L362.344 31.1971C361.49 30.7041 361.197 29.6123 361.69 28.7585L364.908 23.186L383.511 25.2307C384.008 25.2853 384.459 25.5459 384.755 25.949L395.827 41.0375L392.61 46.61Z",
  fill: "white"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.304 300.332C147.304 300.332 145.358 296.338 144.842 291.331C144.582 288.805 144.686 286.022 145.589 283.363C148.278 275.438 154.515 274.436 160.32 277.787C166.126 281.14 168.376 287.042 162.859 293.334C157.338 299.627 147.304 300.332 147.304 300.332Z",
  fill: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M150.846 294.197C150.846 294.197 149.541 291.498 149.201 288.113C149.03 286.404 149.105 284.522 149.718 282.722C151.545 277.356 155.754 276.668 159.663 278.925C163.574 281.182 165.081 285.171 161.349 289.437C157.615 293.703 150.846 294.197 150.846 294.197Z",
  fill: "#FFA621"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M154.389 288.062C154.389 288.062 153.593 286.584 153.326 284.759C153.191 283.838 153.191 282.829 153.496 281.877C154.403 279.038 156.756 278.763 159.007 280.062C161.259 281.362 162.197 283.537 160.192 285.743C158.187 287.949 154.389 288.062 154.389 288.062Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M179.234 279.61C178.872 280.238 178.069 280.453 177.44 280.09L149.388 263.894C148.76 263.532 148.544 262.728 148.907 262.1L150.439 259.447L180.766 276.956L179.234 279.61Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.254 281.212C172.892 281.84 172.089 282.055 171.46 281.693L150.99 269.874C150.361 269.511 150.146 268.708 150.509 268.08L152.041 265.426L174.786 278.558L173.254 281.212Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.651 277.249C185.047 278.296 183.708 278.655 182.661 278.05L148.543 258.352C147.496 257.748 147.138 256.409 147.742 255.362L160.504 233.258C160.872 232.621 161.535 232.211 162.269 232.167L185.828 230.758C186.703 230.705 187.524 231.18 187.916 231.963L198.475 253.071C198.804 253.729 198.781 254.508 198.413 255.145L185.651 277.249Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.586 267.77L181.979 255.344L168.549 247.591L154.984 248.947L152.109 253.928C151.504 254.974 151.863 256.313 152.91 256.917L181.721 273.551C182.768 274.156 184.106 273.797 184.711 272.75L187.586 267.77Z",
  fill: "#DEDCDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.345 233.741C186.111 233.26 185.608 232.97 185.075 233.007L162.78 234.431C161.83 234.497 161.264 235.52 161.712 236.36L171.893 255.918C172.129 256.359 172.595 256.629 173.095 256.612L195.123 255.65C196.075 255.618 196.677 254.616 196.26 253.761L186.345 233.741Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.652 277.25C185.047 278.296 183.709 278.655 182.662 278.051L148.544 258.353C147.497 257.748 147.138 256.41 147.742 255.363L151.687 248.531L174.495 251.037C175.105 251.104 175.658 251.424 176.021 251.918L189.596 270.417L185.652 277.25Z",
  fill: "white"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M-254 61.8613H480V401.336H-254V61.8613Z",
  fill: "#C4C4C4"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1625_15661)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 273.889,
  cy: 449.377,
  r: 125.213,
  transform: "rotate(13.722 273.889 449.377)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 276.212,
  cy: 447.854,
  r: 123.946,
  transform: "rotate(13.722 276.212 447.854)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 354.253,
  cy: 420.312,
  r: 125.213,
  transform: "rotate(13.722 354.253 420.312)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 472.387,
  cy: 470.346,
  r: 125.213,
  transform: "rotate(13.722 472.387 470.346)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 586.075,
  cy: 508.47,
  r: 125.213,
  transform: "rotate(13.722 586.075 508.47)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171.594,
  cy: 430.326,
  r: 125.213,
  transform: "rotate(13.722 171.594 430.326)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.2385,
  cy: 351.927,
  r: 125.213,
  transform: "rotate(13.722 40.2385 351.927)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -28.2703,
  cy: 326.908,
  r: 125.213,
  transform: "rotate(13.722 -28.2703 326.908)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -149.396,
  cy: 324.968,
  r: 125.213,
  transform: "rotate(13.722 -149.396 324.968)",
  fill: "#0F5979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 226.907,
  cy: 417.404,
  r: 72.4729,
  transform: "rotate(13.722 226.907 417.404)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 282.383,
  cy: 404.667,
  r: 72.4729,
  transform: "rotate(13.722 282.383 404.667)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 358.513,
  cy: 394.699,
  r: 72.4729,
  transform: "rotate(13.722 358.513 394.699)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 422.796,
  cy: 440.796,
  r: 72.4729,
  transform: "rotate(13.722 422.796 440.796)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 429.903,
  cy: 430.555,
  r: 72.4729,
  transform: "rotate(13.722 429.903 430.555)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 508.432,
  cy: 472.07,
  r: 72.4729,
  transform: "rotate(13.722 508.432 472.07)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153.41,
  cy: 393.365,
  r: 72.4729,
  transform: "rotate(13.722 153.41 393.365)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74.9665,
  cy: 361.123,
  r: 72.4729,
  transform: "rotate(13.722 74.9665 361.123)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.98408,
  cy: 337.398,
  r: 72.4729,
  transform: "rotate(13.722 7.98408 337.398)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -71.7044,
  cy: 311.757,
  r: 72.4729,
  transform: "rotate(13.722 -71.7044 311.757)",
  fill: "#1B6889"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 251.109,
  cy: 414.754,
  r: 42.7709,
  transform: "rotate(13.722 251.109 414.754)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 278.993,
  cy: 402.743,
  r: 42.7709,
  transform: "rotate(13.722 278.993 402.743)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 336.419,
  cy: 431.004,
  r: 42.7709,
  transform: "rotate(13.722 336.419 431.004)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 387.512,
  cy: 441.217,
  r: 42.7709,
  transform: "rotate(13.722 387.512 441.217)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 322.168,
  cy: 399.468,
  r: 42.7709,
  transform: "rotate(13.722 322.168 399.468)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 362.816,
  cy: 410.314,
  r: 42.7709,
  transform: "rotate(13.722 362.816 410.314)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 200.715,
  cy: 420.793,
  r: 42.7709,
  transform: "rotate(13.722 200.715 420.793)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139.145,
  cy: 390.704,
  r: 42.7709,
  transform: "rotate(13.722 139.145 390.704)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102.856,
  cy: 380.805,
  r: 42.7709,
  transform: "rotate(13.722 102.856 380.805)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109.178,
  cy: 378.259,
  r: 42.7709,
  transform: "rotate(13.722 109.178 378.259)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.1037,
  cy: 379.428,
  r: 42.7709,
  transform: "rotate(13.722 22.1037 379.428)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -18.804,
  cy: 382.35,
  r: 42.7709,
  transform: "rotate(13.722 -18.804 382.35)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105.088,
  cy: 379.428,
  r: 42.7709,
  transform: "rotate(13.722 105.088 379.428)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71.1925,
  cy: 378.259,
  r: 42.7709,
  transform: "rotate(13.722 71.1925 378.259)",
  fill: "#72B3CF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.179 444.374C221.445 395.016 256.66 312.614 274.274 278.29L174.699 450.759C147.802 497.346 285.314 572.773 239.179 444.374ZM255.876 282.685C231.384 317.741 182.965 375.274 136.869 385.306C-42.6742 424.38 119.514 520.663 163.579 444.34L163.58 444.34L174.698 450.759L274.273 278.289L262.379 271.422L255.876 282.685Z",
  fill: "url(#paint0_linear_1625_15661)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M193.128 437.884C185.958 385.929 235.496 311.903 259.352 281.583L128.618 431.814C134.199 437.52 141.993 449.402 150.335 462.12C176.795 502.461 208.769 551.208 193.128 437.884ZM241.127 281.604C210.525 310.596 151.24 355.046 104.008 360.334C5.31718 371.382 48.162 390.244 86.9674 407.329L86.9677 407.329C99.8352 412.994 112.259 418.464 118.93 423.388L118.932 423.386L128.617 431.815L259.352 281.583L248.991 272.567L241.127 281.604Z",
  fill: "url(#paint1_linear_1625_15661)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.928 416.316C212.699 394.667 252.847 316.634 267.177 280.814L202.44 469.149C193.885 466.957 175.703 467.436 156.658 467.937C103.89 469.326 44.5034 470.89 164.928 416.316ZM276.65 454.719C253.376 413.75 265.422 339.314 275.884 297.738L280.167 285.28L279.32 284.989L267.178 280.815L202.441 469.15L214.586 473.325C221.993 476.557 233.906 484.948 246.621 493.905C286.299 521.854 333.798 555.312 276.65 454.719Z",
  fill: "url(#paint2_linear_1625_15661)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M285.925 435.758C292.148 437.278 298.324 437.231 303.901 435.893C308.615 441.42 315.429 445.726 323.541 447.707C328.884 449.011 334.192 449.161 339.117 448.33C341.483 449.851 344.074 451.153 346.854 452.186C351.651 459.2 359.623 464.808 369.417 467.2C370.613 467.492 371.807 467.729 372.996 467.912C377.106 476.772 385.769 484.028 396.916 486.75C401.189 487.793 405.446 488.077 409.505 487.694C414.159 494.608 421.872 500.107 431.36 502.424C449.46 506.843 467.164 498.011 470.904 482.696C474.644 467.381 463.003 451.383 444.903 446.963C441.021 446.015 437.157 445.677 433.446 445.881C428.951 438.203 420.92 432.062 410.869 429.608C409.52 429.279 408.173 429.025 406.834 428.844C402.95 422.062 396.189 416.35 387.648 413.176C382.851 406.162 374.88 400.554 365.086 398.162C359.616 396.827 354.189 396.644 349.157 397.441C345.614 395.128 341.545 393.335 337.083 392.246C330.86 390.726 324.685 390.773 319.107 392.111C314.393 386.584 307.579 382.278 299.468 380.297C285.684 376.932 272.131 381.251 264.798 390.266C264.509 390.188 264.218 390.114 263.925 390.042C255.101 387.888 246.37 388.883 239.306 392.244C229.165 390.903 219.492 393.62 212.73 399.175C209.967 397.723 206.947 396.568 203.723 395.781C195.368 393.74 187.097 394.524 180.245 397.466C176.63 387.482 166.987 378.958 154.274 375.853C153.907 375.763 153.539 375.679 153.173 375.6C149.006 366.966 140.313 359.859 129.172 357.138C120.148 354.935 111.223 356.026 104.077 359.571C100.341 356.916 95.966 354.877 91.1218 353.695C75.2497 349.819 59.611 356.423 53.4038 368.749C51.0716 367.654 48.5752 366.766 45.9422 366.123C32.8074 362.915 19.8809 366.687 12.3483 374.851C11.1149 374.417 9.8446 374.038 8.54079 373.72C-3.27903 370.834 -14.9302 373.599 -22.6338 380.131C-26.5631 377.228 -31.2421 374.993 -36.4572 373.72C-54.5569 369.3 -72.2612 378.133 -76.0009 393.448C-79.7405 408.763 -68.0994 424.761 -49.9997 429.181C-38.1799 432.067 -26.5287 429.301 -18.8251 422.77C-14.8958 425.673 -10.2168 427.907 -5.00165 429.181C8.1331 432.388 21.0596 428.616 28.5922 420.453C29.8256 420.887 31.0959 421.265 32.3997 421.584C42.513 424.053 52.5028 422.385 60.0021 417.761C62.9778 419.416 66.2663 420.72 69.8011 421.584C78.8485 423.793 87.7971 422.691 94.9522 419.123C99.2107 422.81 104.535 425.629 110.593 427.108C117.204 428.722 123.774 428.519 129.639 426.841C132.963 428.794 136.693 430.328 140.732 431.314C149.36 433.421 157.884 432.66 164.912 429.705C168.354 439.699 177.742 448.204 190.181 451.242C201.83 454.086 213.316 451.441 221.02 445.111C223.784 446.564 226.803 447.718 230.027 448.506C238.851 450.66 247.581 449.665 254.645 446.304C266.903 447.925 278.478 443.617 285.052 435.535C285.341 435.612 285.632 435.687 285.925 435.758Z",
  fill: "#C4E6F4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M265.077 274.297C265.077 274.297 276.337 273.504 288.009 268.278C293.899 265.643 299.891 261.878 304.595 256.513C318.617 240.527 312.898 225.529 298.15 217.014C283.396 208.496 267.549 211.043 260.713 231.178C253.879 251.319 265.077 274.297 265.077 274.297Z",
  fill: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M274.076 258.708C274.076 258.708 281.672 258.152 289.553 254.597C293.53 252.804 297.578 250.247 300.76 246.61C310.245 235.773 306.413 225.637 296.48 219.903C286.544 214.166 275.852 215.916 271.207 229.548C266.563 243.184 274.076 258.708 274.076 258.708Z",
  fill: "#FFA621"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M283.076 243.118C283.076 243.118 287.338 242.991 291.693 241.26C293.891 240.387 296.111 239.106 297.82 237.225C302.914 231.621 300.53 226.094 294.811 222.792C289.09 219.489 283.112 220.188 280.805 227.401C278.498 234.616 283.076 243.118 283.076 243.118Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M270.109 177.707C269.187 179.303 269.734 181.344 271.33 182.265L342.61 223.419C344.206 224.34 346.246 223.793 347.168 222.197L351.061 215.455L274.002 170.965L270.109 177.707Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M274.181 192.901C273.259 194.497 273.806 196.538 275.402 197.46L327.417 227.49C329.013 228.412 331.054 227.865 331.975 226.269L335.868 219.526L278.074 186.159L274.181 192.901Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M267.151 160.587C265.615 163.247 266.526 166.649 269.186 168.184L355.877 218.236C358.537 219.771 361.938 218.86 363.474 216.2L395.901 160.034C396.836 158.416 396.895 156.437 396.059 154.766L369.23 101.132C368.234 99.141 366.147 97.9358 363.924 98.0688L304.062 101.651C302.196 101.763 300.512 102.804 299.578 104.422L267.151 160.587Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.552 144.286L320.019 140.84L354.142 160.541L368.39 192.113L361.084 204.768C359.548 207.428 356.147 208.34 353.487 206.804L280.281 164.538C277.621 163.003 276.71 159.602 278.245 156.942L285.552 144.286Z",
  fill: "#DEDCDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362.009 103.784C363.365 103.69 364.641 104.427 365.238 105.648L390.429 156.517C391.491 158.691 389.959 161.237 387.541 161.317L331.569 163.762C330.298 163.804 329.114 163.121 328.515 161.999L302.646 112.303C301.507 110.169 302.946 107.57 305.359 107.403L362.009 103.784Z",
  fill: "#F05B3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M267.15 160.588C265.614 163.247 266.525 166.649 269.185 168.184L355.877 218.236C358.536 219.771 361.938 218.86 363.473 216.2L373.496 198.84L339.003 151.835C338.081 150.579 336.675 149.767 335.127 149.597L277.172 143.228L267.15 160.588Z",
  fill: "white"
}));

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1625_15661",
  x1: 262.851,
  y1: 271.694,
  x2: 132.659,
  y2: 497.193,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4092B5",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#B7DCED",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.692708,
  stopColor: "#B7DCED",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1625_15661",
  x1: 258.445,
  y1: 280.794,
  x2: 114.852,
  y2: 445.802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4092B5",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#B7DCED",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.692708,
  stopColor: "#B7DCED",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1625_15661",
  x1: 269.865,
  y1: 281.738,
  x2: 195.442,
  y2: 498.251,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4092B5",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#B7DCED",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.692708,
  stopColor: "#B7DCED",
  stopOpacity: 0
})));

function SvgEnvelockets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 401,
    viewBox: "0 0 480 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1625_15661",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -254,
    y: 61,
    width: 734,
    height: 341
  }, _ref8), _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelockets);
export default __webpack_public_path__ + "static/media/envelockets.6576481c.svg";
export { ForwardRef as ReactComponent };